import _sortBy from 'lodash.sortby';
import { computed } from '@ember/object';
import { filterBy } from '@ember/object/computed';
import Service, { inject as service } from '@ember/service';
import { isNone } from '@ember/utils';
import Ember from 'ember';
import { task } from 'ember-concurrency';
import { timeout } from 'ember-concurrency';
import { isBrowserWindowVisible } from 'cio/utils/dom';
import DS from 'ember-data';
import EnvironmentService from './environment';
import RavenService from './raven';
import BackfillModel from 'cio/models/backfill';

const FETCH_THROTTLE = 30 * 1000;

export default class BackfillsService extends Service {
  @service store!: DS.Store;
  @service environment!: EnvironmentService;
  @service raven!: RavenService;

  all: BackfillModel[] = [];

  @filterBy('all', 'visible') visible!: BackfillModel[];

  @computed('visible.@each.created')
  get latest(): BackfillModel[] {
    return _sortBy(this.visible, ['created']).reverse().slice(0, 5);
  }

  @computed('visible.@each.pending')
  get hasPending(): boolean {
    return this.visible.isAny('pending');
  }

  fetch = task({ keepLatest: true }, async () => {
    if (
      isNone(this.environment.current?.id) ||
      ('fakePostSignup' in this.environment.current && this.environment.current.fakePostSignup === true)
    ) {
      return;
    }

    do {
      try {
        // Only send the API request if the browser window/tab is visible. We
        // don't need the latest state in background tabs
        if (isBrowserWindowVisible()) {
          this.set('all', await this.store.findAll('backfill'));
        }
      } catch (e) {
        this.get('raven').captureException(e);
      }

      if (Ember.testing) {
        break;
      }

      await timeout(FETCH_THROTTLE);
    } while (this.hasPending);
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    backfills: BackfillsService;
  }
}
